import { ReactNode } from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import NvRoleBadge from 'shared/components/nv-role-badge';
import { Recipient } from 'redux/schemas/models/course-communication';
import {
  halfSpacing, standardSpacing, quarterSpacing, largeSpacing,
} from 'styles/global_defaults/scaffolding';
import { info, warning } from 'styles/global_defaults/colors';

type AudienceSummaryProps = {
  audienceLabel: ReactNode;
};

const styles = css`
  background-color: ${info};
  border-radius: ${halfSpacing}px;
  padding: ${standardSpacing}px ${largeSpacing}px;

  .icons-wrapper {
    width: ${standardSpacing + quarterSpacing}px;
    margin-right: ${halfSpacing}px;

    .icon {
      color: ${warning};
    }

    &.recipient-icons {
      position: relative;
      left: ${quarterSpacing}px;
    }
  }

  .audience-row + .audience-row {
    margin-top: ${halfSpacing}px;
  }
`;

const AudienceSummary = ({ audienceLabel }: AudienceSummaryProps) => (
  <div css={styles}>
    <div className='audience-row d-flex align-items-center'>
      <div className='icons-wrapper'>
        <NvIcon icon='calendar' size='xss-smallest' />
      </div>
      <div className='content font-weight-bold text-medium'>{t.LEARNER_PROGRESS.CONTACT_BAR.MODAL.AUDIENCE_SEND_NOW()}</div>
    </div>
    <div className='audience-row d-flex align-items-center'>
      <div className='icons-wrapper recipient-icons'>
        <NvRoleBadge recipient={Recipient.LEARNERS} />
      </div>
      <div className='content text-medium font-weight-bold'>{audienceLabel}</div>
    </div>
  </div>
);

export default AudienceSummary;
